import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AgentClientsState } from "../../types";
import { agentAxiosObj } from "../../../config/apiClients";
import { ClientFilterParams } from "../../../utils/interface";

const initialState: AgentClientsState = {
  isLoading: false,
  isClientLoading: false,
  clients: [],
  client: null,
  pagination: {
    totalItems: 0,
    currentPage: 1,
    totalPages: 1,
    hasNextPage: false
  }
}

export const getAllClients = createAsyncThunk(
  "/clients",
  async ({ paramPage, paramLimit, search, lockedUsers, isBlacklist }: ClientFilterParams, { rejectWithValue }) => {
    try {
      // lockedUsers=true lists the Deleted Accounts tab, blacklistUsers=true the Blacklisted tab; without either the API leaves both out
      const url = `/clients${paramPage && paramLimit ? `?paramPage=${paramPage}&paramLimit=${paramLimit}` : ""}${search ? `&search=${search}` : ""}${lockedUsers ? "&lockedUsers=true" : ""}${isBlacklist ? "&blacklistUsers=true" : ""}`
      const response = await agentAxiosObj.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Clients' });
    }
  }
)


export const getClientById = createAsyncThunk(
  "/clients/getById",
  async (clientId: string, { rejectWithValue }) => {
    try {
      const response = await agentAxiosObj.get(`/clients/${clientId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to fetch client' });
    }
  }
)

const agentClientsSlice = createSlice({
  name: "agentClients",
  initialState,
  reducers: {
    setClient: (state, action) => {
      state.client = action.payload;
    },
    resetClients(state) {
      state.clients = [];
      state.pagination = {
        totalItems: 0,
        currentPage: 1,
        hasNextPage: false,
        totalPages: 1,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllClients.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllClients.fulfilled, (state, action) => {
        state.isLoading = false;
        state.clients = action.payload.payload.kAllSAClients.allUsers;
        state.pagination = {
          totalItems: action.payload.payload.kAllSAClients.totalItems,
          currentPage: action.payload.payload.kAllSAClients.page,
          totalPages: action.payload.payload.kAllSAClients.totalPages,
          hasNextPage: action.payload.payload.kAllSAClients.hasNextPage
        };
      })
      .addCase(getAllClients.rejected, (state) => {
        state.isLoading = false;
        state.clients = [];
      })
      .addCase(getClientById.pending, (state) => {
        state.isClientLoading = true;
      })
      .addCase(getClientById.fulfilled, (state, action) => {
        state.isClientLoading = false;
        state.client = action.payload.payload;
      })
      .addCase(getClientById.rejected, (state) => {
        state.isClientLoading = false;
        state.client = null;
      });
  }
});

export const { setClient, resetClients } = agentClientsSlice.actions;

export default agentClientsSlice.reducer;